import React from 'react';
import { styled } from '@mui/material/styles';
import { Stack, IconButton } from '@mui/material';
import Programas from './Programas';
import Convocatoria from './Convocatoria';
import Descripcion from './Descripcion';
import Objetivos from './Objetivos';
import Conclusion from './Conclusion';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import VolumeOffIcon from '@mui/icons-material/VolumeOff';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';
import RestartAltIcon from '@mui/icons-material/RestartAlt';

const B = styled('span')({
  color: '#268c83',
  fontWeight: 'bold',
});

const Video = styled('video')({
  maxWidth: '100%',
  maxHeight: `400px`,
});

const ResetButton = ({ onClick }) => (
  <IconButton onClick={onClick} sx={{ color: 'white', fontSize: 40 }} aria-label="Reiniciar video">
    <RestartAltIcon fontSize="large" />
  </IconButton>
);

const PlayButton = ({ videoControls, onClick }) => (
  <IconButton
    onClick={onClick}
    sx={{ color: 'white', fontSize: 40 }}
    aria-label={videoControls.paused ? 'Reproducir video' : 'Pausar video'}
  >
    {videoControls.paused ? <PauseIcon fontSize="large" /> : <PlayArrowIcon fontSize="large" />}
  </IconButton>
);

const UnMuteButton = ({ videoControls, onClick }) => (
  <IconButton
    onClick={onClick}
    sx={{ color: 'white', fontSize: 40 }}
    aria-label={videoControls.muted ? 'Activar sonido' : 'Silenciar video'}
  >
    {videoControls.muted ? <VolumeOffIcon fontSize="large" /> : <VolumeUpIcon fontSize="large" />}
  </IconButton>
);

const Home = (props) => {
  const [videoControls, setVideoControls] = React.useState({ muted: true, paused: true });

  const handleVideoControls = (type) => {
    setVideoControls((prevState) => ({ ...prevState, [type]: !prevState[type] }));
  };

  const handleToggleMute = () => {
    let video = document.getElementById('video');
    handleVideoControls('muted');
    video.muted = !video.muted;
  };

  const handlePlayVideo = () => {
    let video = document.getElementById('video');
    if (video.paused) {
      video.play();
    } else {
      video.pause();
    }
    handleVideoControls('paused');
  };

  const handleResetVideo = () => {
    let video = document.getElementById('video');
    video.currentTime = 0;
    video.play();
  };

  return (
    <main role="main" style={{ maxWidth: '100%' }}>
      <Stack sx={{ width: '100%', marginTop: -6, flexGrow: 1 }}>
        <Stack sx={{ backgroundColor: '#181C2B', position: 'relative' }}>
          <Video
            id="video"
            src={'https://s3.amazonaws.com/lideresenmovimiento.s3/videohome2025.mp4'}
            controls={false}
            autoPlay
            playsInline
            muted
            loop
            aria-label="Video de introducción al programa Líderes en Movimiento 2025"
          />
          <Stack sx={{ position: 'absolute', right: 0, bottom: 0 }}>
            {!videoControls.muted && <ResetButton onClick={handleResetVideo} videoControls={videoControls} />}
            {!videoControls.muted && <PlayButton onClick={handlePlayVideo} videoControls={videoControls} />}
            <UnMuteButton onClick={handleToggleMute} videoControls={videoControls} />
          </Stack>
        </Stack>
        <Descripcion B={B} />
        <Objetivos />
        {/* <Programas /> */}
        <Convocatoria />
        <Conclusion B={B} />
      </Stack>
    </main>
  );
};

export default Home;
